import { SetPasswordState } from '@pages/set-password/store/state/set-password.state';

export const setPasswordState = [SetPasswordState];
